import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  getDivision,
  getParticularPage,
  getNext,
  getPrevious,
  createDivision,
  updateDivision,
  handleSearch,
} from "./thunk";

const initialState = {
  divisions: [],
  edit: false,
  division: null,
  count: null,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingUpdated: false,
  loadingDivision: false,
  loadingNext: false,
  showCreateModal: false,
};

export const divisionSlice = createSlice({
  name: "division",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    divisionEditSuccess: (state, action) => {
      state.edit = true;
      state.division = state.divisions.find((division) => division.id === action.payload);
    },
    clearAllDivision: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingDivision = false;
      state.division = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createDivision.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createDivision.fulfilled, (state, action) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(createDivision.rejected, (state) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(updateDivision.pending, (state) => {
      state.loadingUpdated = true;
    });
    builder.addCase(updateDivision.fulfilled, (state, action) => {
      state.loadingUpdated = false;
      state.edit = false;
    });
    builder.addCase(updateDivision.rejected, (state) => {
      state.loadingUpdated = false;
    });
    builder.addMatcher(
      isAnyOf(
        getDivision.pending,
        getParticularPage.pending,
        getPrevious.pending,
        getNext.pending,
        handleSearch.pending
      ),
      (state) => {
        state.loadingDivision = true;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getDivision.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingDivision = false;
        state.divisions = action.payload.data;
        state.count = action.payload.totalCount;

        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getDivision.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingDivision = false;
      }
    );
  },
});

export const { setShowCreateModal, goToPage, divisionEditSuccess, clearAllDivision } = divisionSlice.actions;

export default divisionSlice.reducer;
